<template>
  <div class = "st-table">
      <el-card shadow="always" style="width: 100%">
        <el-form label-position="left" label-width="145px" label-colon>
          <el-row :gutter="16" type="flex" justify=start>
            <el-col :span="8">
              <el-form-item label="Week" :span="8">
                  <el-date-picker
                    v-model="week"
                    placeholder="Please Input"
                    type="week"
                    style="width: 260px"
                    :format="start+ ' to '+ end" @change="newDateWeekHandle"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" :span="6" @click="getReportList">
                  Search
                </el-button>
              </el-col>
              <el-col :span="1">
                <el-button type="primary" router @click="handleOpenRouter">
                  New Report
                </el-button>
              </el-col>
          </el-row>
        </el-form>
      </el-card>
    <br/>
      <el-card shadow="always" title="Weekly Report" label-width="145px" label-colon>
        <el-form>
          <el-row :gutter="16">
            <el-table
            :data="reportList"
            border
            show-summary
            :summary-method="getSummaries"
            style="width: 100%">
            <el-table-column
              prop="category"
              label="Class-Lv1"
              width="100"
            >
            </el-table-column>

            <el-table-column
              prop="category2nd"
              label="Class-Lv2"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="category3rd"
              label="Class-Lv3"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="subClass"
              label="Sub Class"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="time"
              label="Hour"
              width="100"
            >
              <template slot-scope="scope">
                <input type="text"
                       v-model="patchItem.time"
                       v-if="isEdit === scope.$index"
                />
                <span v-else>{{scope.row.time}}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="percentage"
              label="Progress"
              width="120"
            >
              <template slot-scope="scope">
                <input type="text"
                       v-model="patchItem.percentage"
                       v-if="isEdit === scope.$index"
                />
                <span v-else>{{scope.row.percentage}}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="description"
              label="Description"
              width="300"
            >
              <template slot-scope="scope">
                <input type="text"
                       v-model="patchItem.description"
                       v-if="isEdit === scope.$index"
                />
                <span v-else>{{scope.row.description}}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="Action"
              width="180">
              <template slot-scope="scope">
                <div v-if="isEdit === scope.$index">
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="handleSave(scope.$index, scope.row)">
                    Save
                  </el-button>
                  <el-button
                    size="small"
                    plain
                    @click="isEdit = -99">
                    Cancel
                  </el-button>
                </div>
                <div v-else>
                  <el-button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="handleEdit(scope.$index, scope.row)">
                    Edit
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    @click="handleDel(scope.$index, scope.row)"
                    >
                    Delete
                  </el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>
          </el-row>
        </el-form>
      </el-card>

<!--    <el-row :gutter="16">-->
<!--      <el-card>-->
<!--        <div-->
<!--          id="report"-->
<!--        >-->
<!--        </div>-->
<!--      </el-card>-->

<!--    </el-row>-->
  </div>
</template>

<script>
import reportApi from '@/api/report.js';
import {PathName} from "@/constant/routeData";


export default {
  name: "reportList",
  data() {
    return {
      loading: false,
      week:"",
      start: "",
      end: "",
      reportList: [],
      bar: [],
      editIndex: -1,
      isEdit: -99,
      patchItem: {
        time:"",
        percentage:"",
        description:"",
      }
    }
  },
  methods: {
    showDate() {
      let startTime = this.dayjs(this.week).subtract(1, "day").$d;
      let endTime = this.dayjs(startTime).add(6, "day").$d;
      this.start = this.dayjs(startTime).format("YYYY-MM-DD");
      this.end = this.dayjs(endTime).format("YYYY-MM-DD");
    },
    newDateWeekHandle() {
      const now = new Date(this.week);
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;

      //const mondayTime = nowTime - (day-1)*oneDayTime;
      const sundayTime = nowTime + (day-2)*oneDayTime;
      const saturdayTime = nowTime + (7-day-1)*oneDayTime;
      this.start = this.$moment(sundayTime).format('YYYY-MM-DD');
      this.end = this.$moment(saturdayTime).format('YYYY-MM-DD');
    },
    getDateWeek() {
      const now = new Date();
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;
      const mondayTime = nowTime - (day-1)*oneDayTime;//默认是周二
      this.week = new Date(mondayTime);
      this.newDateWeekHandle();
    },
    handleChange(cateVal) {
      console.log(cateVal);
    },
    handleEdit(index, row) {
      this.patchItem.time = row.time
      this.patchItem.description = row.description
      this.patchItem.percentage = row.percentage
      this.isEdit = index
    },
    handleSave(index, row) {
      let para = {id: row.id}
      let data = this.patchItem
      data['description'] = this.patchItem.description
      data['time'] = this.patchItem.time
      data['percentage'] = this.patchItem.percentage
      reportApi.patchReport(para, data).then(resp=>{
        this.$message.success(
          {
            message: resp['msg'],
            type: "success"
          }
        )
        this.getReportList()
      })
      this.isEdit = -99
    },
    handleDel(index, row) {
      this.$confirm('Delete the report, continue?', 'Tips', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(() => {
        let para = { id: row.id }
        reportApi.deleteReport(para).then(resp => {
          this.$message.success({
            message: resp['msg'],
            type: "success"
          })
          this.getReportList()
        })
      })
    },
    getReportList() {
      let para = {}
      para['week_start'] = this.start
      para['week_end'] = this.end
      reportApi.getReport(para).then(
        res => {
          this.reportList = res.data.data
        }
      )
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'time') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      return sums
    },
    handleOpenRouter() {
      let routeData = this.$router.resolve({name: PathName.WeeklyReport});
      window.open(routeData.href, '_blank');
    },
  },
  created() {
    this.getDateWeek()
  },
  mounted() {
    this.getReportList()
  }
  // computed: {
  //   timeDefault () {
  //     let date = new Date()
  //
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>
